'use client'

import { useState, useEffect } from "react"
import SearchBar from "./SearchBar"
import Link from "next/link"
import SearchNav from "@/components/search/SearchNav"
import { useSearchParams } from "next/navigation"
import { useHandleSearchFromSearchBar } from "@/components/search/useHandleSearchFromSearchBar"

type SearchHeaderProps = {
    aroeven: Aroeven
}

export default function SearchHeader({
    aroeven
}: SearchHeaderProps) {

    const searchParams = useSearchParams()

    const [search, setSearch] = useState(Object.fromEntries(new URLSearchParams(searchParams)))

    useEffect(() => {
        setSearch({
            //...search,
            ...Object.fromEntries(new URLSearchParams(searchParams))
        })
    }, [searchParams])

    const handleSearch = useHandleSearchFromSearchBar(search, 'search', 'object', 'EducationCourse')

    return (
        <>
            <section className="navscroll d-none recherche pt-10 pb-0">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-xl-3 d-flex align-items-start" />
                        <div className="col-lg-12 col-xl-9">
                            <div className="tabs -underline">
                                <SearchBar
                                    search={search}
                                    setSearch={setSearch}
                                    handleSearch={handleSearch}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="navhead recherche pt-40 pb-40 bg-bloc">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-xl-3 d-flex align-items-start">
                            <Link href={'/recherche' + ('query' in searchParams ? '?query=' + searchParams['query'] : '')} className="button-primary secteur d-block mt-80">
                                <i className="mr-15 fi fi-bs-cross-small" /> Education - Formation
                            </Link>
                        </div>
                        <div className="col-lg-12 col-xl-9">
                            <div className="tabs -underline mt-80">
                                <SearchNav object={'EducationCourse'} sector={'EducationCourse'} />
                                <SearchBar
                                    search={search}
                                    setSearch={setSearch}
                                    handleSearch={handleSearch}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}